import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface StepEntry {
  title: string;
  description: string;
}

export interface StepsProps {
  title?: string;
  steps: StepEntry[];
}

export function Steps({ title, steps }: StepsProps) {
  return (
    <section className="bg-stone-50 py-16">
      <Container>
        {title ? <h2 className="mb-10 text-3xl font-bold tracking-tightish">{title}</h2> : null}
        <ol className="grid gap-6 md:grid-cols-3 lg:grid-cols-5">
          {steps.map((step, idx) => (
            <li key={step.title} className="rounded-xl border border-stone-200 bg-white p-5 shadow-soft">
              <span className="font-mono text-sm font-bold text-accent-700">0{idx + 1}</span>
              <h3 className="mt-2 text-lg font-semibold text-stone-900">{step.title}</h3>
              <p className="mt-1 text-sm text-stone-600">{step.description}</p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}

export const StepsConfig: ComponentConfig<StepsProps> = {
  fields: {
    title: { type: 'text' },
    steps: {
      type: 'array',
      arrayFields: { title: { type: 'text' }, description: { type: 'textarea' } },
      defaultItemProps: { title: 'Étape', description: '' },
    },
  },
  defaultProps: {
    title: 'Comment ça marche',
    steps: [
      { title: 'Diagnostic', description: 'SIRET et 5 questions, 60 secondes.' },
      { title: 'Estimation', description: 'Primes min/max chiffrées, sources documentées.' },
      { title: 'Devis', description: 'Cadrage avec un expert, sans engagement.' },
      { title: 'Montage', description: 'Dossier monté de A à Z, conformité OPERAT.' },
      { title: 'Versement', description: 'Prime versée par l’organisme officiel après contrôle de conformité.' },
    ],
  },
  render: Steps,
};
